import React from 'react'
import CookieConsent from 'react-cookie-consent'
import Link from '@/components/Common/Link'

const CookieRgpd: React.FC = () => {
  return (
    <CookieConsent
      location="bottom"
      cookieName="acceptCookieStore"
      buttonText={"j'accepte"}
      enableDeclineButton
      declineButtonText={'je refuse'}
      expires={150}
      // Use custom classes instead of default inline styles
      disableStyles
      overlay
      overlayStyle={{ zIndex: 1200, background: 'rgba(0,0,0,0.3)' }}
      containerClasses="fixed bottom-4 inset-x-2 md:inset-auto md:right-4 z-[1201] w-auto pointer-events-auto max-w-3xl md:min-w-[720px] bg-white text-slate-800 rounded-xl shadow-[0_16px_60px_rgba(0,0,0,0.35)] border border-slate-200 p-4 md:p-6 md:flex md:items-center md:gap-4"
      contentClasses="flex-1"
      buttonClasses="rounded-md bg-[#0A185F] text-white px-4 py-2 font-semibold hover:bg-[#0b1e7a] transition"
      declineButtonClasses="rounded-md border border-slate-300 text-slate-700 px-4 py-2 font-semibold hover:bg-slate-50 transition"
      buttonWrapperClasses="mt-3 md:mt-0 md:ml-4 flex items-center shrink-0 space-x-3"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start md:items-center gap-3">
          <div className="shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
            {/* simple shield icon */}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
            >
              <path
                d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
              />
              <path
                d="M9 12l2 2 4-4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="xs leading-6 md:text-xs md:leading-7">
            <div className="text-slate-700">
              Ce site web utilise des cookies pour améliorer l'expérience de l'utilisateur{' '}
              <Link
                href={'https://pharmedigroup.com/legal/'}
                target={'_blank'}
                className="text-[#0A185F] underline underline-offset-2 hover:opacity-90"
              >
                Pour plus d'informations, vous pouvez consulter notre Politique de gestion des
                cookies.
              </Link>
            </div>
          </div>
        </div>
        {/* Buttons are rendered by the library and will appear here, aligned via buttonWrapperClasses */}
      </div>
    </CookieConsent>
  )
}

export default CookieRgpd
